'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  minHeight: '100vh',

  content: {
    backgroundColor: _reactackleCore.bodyBackgroundColor
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-app/dist/styles/theme.js
// module id = 541
// module chunks = 0